<app-loader class="loader" [ngStyle]="{ display: displayStyles }"></app-loader>
<div class="blue">
  <app-navbar></app-navbar>
  <style>
    .mat-horizontal-stepper-header .mat-step-icon {
      display: none !important;
    }
    .mat-horizontal-stepper-header-container {
      display: none;
    }
  </style>
  <div class="struct-heading">
    <h1>REGISTER</h1>
  </div>

  <div class="empty">
    <div *ngIf="showReminder" class="reminder">
      <h2>NOTE</h2>
      <p>
        This competition is only for startups operating or looking to expand in the countries of UAE, Saudi Arabia, Bahrain, Kuwait, Oman and Kuwait.
      </p>
      <br />
      <!-- <em>Ignore this if all have already been done</em> -->
      <!-- <i
        class="fa fa-xmark"
        aria-hidden="true"
        (click)="showReminder = false"
      ></i> -->
    </div>
  </div>

  <app-sqanimation></app-sqanimation>
  <div class="form-container">
    <!-- <mat-horizontal-stepper #stepper> -->
    <!-- <mat-stepper [linear]="isLinear" #stepper>
  <mat-step [stepControl]="firstFormGroup"> -->
    <!-- <div class="form">
      <h1
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 3rem;
        "
      >
        <i
          class="fa fa-circle"
          style="font-size: small; color: #00c4f4"
          aria-hidden="true"
        ></i>
        <span class="headi">REGISTER</span>
        <i
          class="fa fa-circle"
          style="font-size: small; color: #00c4f4"
          aria-hidden="true"
        ></i>
      </h1> -->

    <form [formGroup]="firstFormGroup" class="main-form" *ngIf="!generatedOTP">
      <!-- <ng-template matStepLabel>Register</ng-template> -->
      <!-- <mat-form-field class="input-field">
        <mat-label class="input-label">Full Name</mat-label>
        <mat-select>
          <mat-option *ngFor="let brand of brands" [value]="brand.value">
            {{ brand.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <!-- <mat-label class="input-label">Full Name</mat-label>
      <br> -->
      <div class="example-form-fields">
        <mat-form-field
          style="width: 48%"
          class="input-field"
          appearance="outline"
        >
          <input
            matInput
            placeholder="Full Name*"
            formControlName="name"
            required
          />
          <mat-error
            *ngIf="firstFormGroup.controls['name'].hasError('required')"
          >
            Name is required!
          </mat-error>
        </mat-form-field>
        <!-- <mat-label class="input-label">Email ID</mat-label> -->
        <mat-form-field
          style="width: 48%"
          class="input-field"
          appearance="outline"
        >
          <input
            matInput
            placeholder="Email ID*"
            name="email"
            pattern="[a-zA-Z0-9.-_]{1,}@[a-z0-9A-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
            formControlName="email"
            required
          />
          <mat-error
            *ngIf="firstFormGroup.controls['email'].hasError('required')"
          >
            Email is required!
          </mat-error>
          <mat-error *ngIf="firstFormGroup.controls['email'].hasError('email')">
            Email is not Valid!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="example-form-fields">
        <mat-form-field
          style="width: 35%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">Gender</mat-label> -->
          <mat-select placeholder="Gender*" formControlName="gender">
            <mat-option *ngFor="let gender of gender" [value]="gender.value">
              {{ gender.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          style="width: 10%"
          class="codecountry input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">Country Code (mandatory)</mat-label> -->
          <mat-select formControlName="countrycode" placeholder="Country Code*">
            <mat-option
              *ngFor="let country of countries"
              [value]="country.countryCallingCode"
            >
              {{ country.countryNameEn }} ({{ country.countryCallingCode }})
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="firstFormGroup.controls['countrycode'].hasError('required')"
          >
            Country Code is required!
          </mat-error>
        </mat-form-field>

        <mat-form-field
          style="width: 50%"
          class="input-contact input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">Contact Number (Country Code mandatory)</mat-label> -->
          <input
            maxlength="10"
            matInput
            placeholder="Contact Number"
            name="contact"
            pattern="[0-9+]{10,10}"
            formControlName="contact"
            required
          />
          <mat-error
            *ngIf="firstFormGroup.controls['contact'].hasError('required')"
          >
            Mobile is required!
          </mat-error>
          <mat-error *ngIf="firstFormGroup.controls['contact'].hasError('min')">
            Mobile No is Wrong!
          </mat-error>
        </mat-form-field>
      </div>
      <!-- <mat-form-field  class="input-field">
        <mat-label class="input-label">Contact Number</mat-label>
        <input matInput placeholder="Contact" formControlName="email" required>
      </mat-form-field> -->
      <div class="example-form-fields">
        <mat-form-field
          *ngIf="isrequired"
          style="width: 32%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">Country</mat-label> -->
          <mat-select
            (selectionChange)="country_reg()"
            formControlName="country"
            placeholder="Country*"
          >
            <mat-option *ngFor="let country of country" [value]="country.value">
              {{ country.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          *ngIf="!isrequired"
          style="width: 100%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">Country</mat-label> -->
          <mat-select
            (selectionChange)="country_reg()"
            formControlName="country"
            placeholder="Country*"
          >
            <mat-option *ngFor="let country of country" [value]="country.value">
              {{ country.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          *ngIf="isrequired"
          style="width: 32%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">State</mat-label> -->
          <mat-select
            formControlName="state"
            placeholder="State*"
            required="{{ isrequired }}"
          >
            <mat-option *ngFor="let state of states" [value]="state.value">
              {{ state.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          *ngIf="isrequired"
          style="width: 32%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">City</mat-label> -->
          <input
            matInput
            placeholder="City*"
            formControlName="city"
            required="{{ isrequired }}"
          />
          <mat-error
            *ngIf="firstFormGroup.controls['city'].hasError('required')"
          >
            City is required!
          </mat-error>
        </mat-form-field>
      </div>

     

      <!-- <mat-form-field  class="input-field">
        <mat-label class="input-label">Password</mat-label>
        <input matInput placeholder="Password" name="password" formControlName="password" required>
      </mat-form-field> -->
      <div class="example-form-fields">
        <mat-form-field
          style="width: 48%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">From where did you hear about Eureka! 2024?*</mat-label> -->
          <mat-select
            formControlName="source"
            placeholder="From where did you hear about Eureka! GCC 2024?*"
          >
            <mat-option *ngFor="let sources of sources" [value]="sources.value">
              {{ sources.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          style="width: 48%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">Referral ID (If any)</mat-label> -->
          <input
            matInput
            placeholder="Referral ID (If any)"
            formControlName="referral"
          />
        </mat-form-field>
      </div>


      <div class="example-form-fields">
        <!-- <mat-form-field
          style="width: 48%"
          class="input-field"
          appearance="outline"
        >
        
          <mat-select
            formControlName="status"
            placeholder="Current professional status?"
          >
            <mat-option *ngFor="let gender of status" [value]="gender.value">
              {{ gender.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <mat-form-field
          style="width: 48%"
          class="input-field"
          appearance="outline"
        >
          <!-- <mat-label class="input-label">Set your team password</mat-label> -->
          <input
            matInput
            formControlName="password"
            placeholder="Set your password"
            [type]="hide ? 'password' : 'text'"
            name="password"
          />
          <button
            style="color: black"
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
          </button>
        </mat-form-field>
      </div>





      <div>
        <!-- <button class="green-button" mat-button matStepperPrevious>Back</button> -->
        <!-- <button class="green-button" mat-button (click)="stepper.reset()">Reset</button> -->
        <button
          class="green-button"
          mat-button
          (click)="generateOTP()"
          [disabled]="isLoading"
        >
          <mat-spinner *ngIf="isLoading" class="spinner"></mat-spinner>
          <span *ngIf="!isLoading">Submit</span>
        </button>
      </div>
    </form>
    <form [formGroup]="verifyFormGroup" class="main-form" *ngIf="generatedOTP">
      <!-- <ng-template matStepLabel>Register</ng-template> -->
      <!-- <mat-form-field class="input-field">
        <mat-label class="input-label">Full Name</mat-label>
        <mat-select>
          <mat-option *ngFor="let brand of brands" [value]="brand.value">
            {{ brand.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <!-- <mat-label class="input-label">Full Name</mat-label>
      <br> -->
      <p>
        An OTP was sent to the given email ({{
          firstFormGroup.controls["email"].value
        }}) for verification. Please enter it here to verify your email.
      </p>
      <div class="example-form-fields" style="justify-content: center">
        <mat-form-field class="input-field" appearance="outline">
          <input matInput placeholder="XXXXXX" formControlName="otp" required />
          <mat-error
            *ngIf="verifyFormGroup.controls['otp'].hasError('required')"
          >
            OTP is required!
          </mat-error>
        </mat-form-field>
        <!-- <mat-label class="input-label">Email ID</mat-label> -->
      </div>

      <div>
        <!-- <button class="green-button" mat-button matStepperPrevious>Back</button> -->
        <!-- <button class="green-button" mat-button (click)="stepper.reset()">Reset</button> -->
        <button
          class="green-button"
          mat-button
          (click)="submit()"
          [disabled]="isLoading"
        >
          <mat-spinner *ngIf="isLoading" class="spinner"></mat-spinner>
          <span *ngIf="!isLoading">Verify</span>
        </button>
      </div>
    </form>
  </div>
  <!-- </mat-step>




</mat-stepper> -->
</div>

<div style="background: #04070a">
  <app-footer></app-footer>
</div>
